import { useEffect, useState } from 'react';
import { captureProductEvent } from '../utils/productAnalytics';
import './MenuSurvey.css';

const STORAGE_KEY = 'menu-ai-feedback-submitted';

const MenuSurvey = ({ placement = 'home' }) => {
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    try {
      setSubmitted(window.localStorage.getItem(STORAGE_KEY) === 'true');
    } catch (_error) {
      setSubmitted(false);
    }
  }, []);

  const handleSubmit = event => {
    event.preventDefault();

    const answer = feedback.trim();

    if (!answer) return;

    captureProductEvent('menu-survey-submitted', {
      placement,
      answer,
      feedback: answer,
    });

    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (_error) {
      // Ignore storage failures; the thank-you state still covers this session.
    }

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <section className="menu-survey menu-survey-complete" aria-label="Menu AI survey">
        <p>Thanks for the feedback.</p>
      </section>
    );
  }

  return (
    <section className="menu-survey" aria-label="Menu AI survey">
      <form onSubmit={handleSubmit}>
        <div className="menu-survey-header">
          <h2>How can we improve Menu AI?</h2>
          <p>Share your feedback, ideas, or anything that did not work as expected.</p>
        </div>

        <label className="menu-survey-feedback-label" htmlFor="menu-survey-feedback">
          Your feedback
        </label>
        <textarea
          id="menu-survey-feedback"
          className="menu-survey-text-input"
          value={feedback}
          onChange={event => setFeedback(event.target.value)}
          placeholder="Tell us what you think..."
          maxLength={1000}
          rows={5}
        />

        <button className="menu-survey-submit" type="submit" disabled={!feedback.trim()}>
          Send feedback
        </button>
      </form>
    </section>
  );
};

export default MenuSurvey;
